const buttonClasses = 'bg-primary-50 text-primary-600';

const buttonHoverClasses = 'hover:bg-primary-900 hover:text-white [&:hover_svg]:fill-white';

const buttonIconClasses = 'fill-primary-600';

const buttonPrimaryLightClasses = {
  buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses],
  buttonIconClasses,
};

export default buttonPrimaryLightClasses;
